function isLogVisible() {
  return process.env.VUE_APP_SHOW_LOGS === "1";
}
export { isLogVisible };
